import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';

/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import DatePicker from 'react-datepicker';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// config
import { systemdata_definitions, systemdata_groups } from './definitiions';

// Components
import AjaxController from '../system/ajaxController';

// Redux slices
import { setActivePage, setUser, setToken } from '../../appSlice';
import { setSubPage2 } from '../menu/menuSlice';

// SemanticUI components
import { Menu, MenuItem, MenuHeader, MenuMenu, Table, TableHeader, TableHeaderCell, TableRow, TableBody, TableCell, Grid, GridRow, GridColumn, Button, Header, HeaderContent, Icon, FormInput, FormSelect, Form, Card, CardContent, CardDescription, FormField, FormGroup, CardHeader, CardMeta, FormTextArea, Segment, Modal } from 'semantic-ui-react'

// Style
import './settings.css';

registerLocale('de', de);
setDefaultLocale('de');













/**
 * 
 * @param {*} param0 
 * @returns 
 */
const Max2SettingsSystemData = () => {
  // local state
  const [activeItem, setActiveItem]         = useState('');
  const [pagination, setPagination]         = useState({ recordsPerPage: 25, actualPage: 0, numberOfPages: 0})
  const [isSearching, setIsSearching]       = useState(false);
  const [result, setResult]                 = useState({ numberOfRecordsTotal: 0, numberOfRecords: 0, records: [] });
  const [searchFilter, setSearchFilter]     = useState({});
  
  // global state
  const dispatch    = useDispatch();
  const backendUrl  = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);



  /**
   * 
   * @param {string} menuItem 
   */
  const handleMenuItemClick = (menuItem, menuItemTitle) => {
    setResult({ numberOfRecordsTotal: 0, numberOfRecords: 0, records: [] });
    setActiveItem(menuItem);
    loadTableData(menuItem, true, true);
    dispatch(setSubPage2(menuItemTitle));
  }
  


  /**
   * 
   */
  const loadTableData = (table, initial = false, searchFilter = null) => {
    let actualPage = initial ? 1 : pagination.actualPage + 1;

    // check if table is defined
    if (typeof systemdata_definitions[table] === "undefined" || typeof systemdata_definitions[table]?.columns === 'undefined') {
      return false;
    } 

    // determine FK tables
    let references = [];
    if (typeof systemdata_definitions[table]?.columns !== "undefined") {
      const cols = systemdata_definitions[table]?.columns;
      for (const key in cols) {
        if (Object.prototype.hasOwnProperty.call(cols, key)) {
          const col = cols[key];
          if (col.FK && typeof col.FK.TABLE !== 'undefined') {
            const tab = systemdata_definitions[col.FK.TABLE]?.table;
            if (!references.includes(tab)) {
              references.push(tab);
            }
          }
        }
      }
    }

    // build request params
    const query = {
      filter:     searchFilter, 
      pagination: {
        ...pagination,
        actualPage: actualPage
      },
      sorting:    { by: systemdata_definitions[table]?.defaultSorting, direction: 'ASC' },
      table:      systemdata_definitions[table]?.table,
      references: references
    }
    
    // run request
    fetchData(query, initial);
  }


  
  /**
   * AJAX API request
   */
  const fetchData = async (query, initial) => {
    try {
      // Controller for AJAX requests
      const api = new AjaxController(backendUrl, () => {
            dispatch(setActivePage('START'));
            dispatch(setUser(null));
            dispatch(setToken(null));
          });

      // show loading animation
      setIsSearching(true);

      // send search request
      const count = await api.get('/settings/systemdata_count/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));
      const response = await api.get('/settings/systemdata_filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));
      
      // display results
      if (response?.records.length) {
        let _records = [...result.records];
        let numberOfRecords = result.numberOfRecords  + response.records.length;

        // reset state result object on filter 
        if (initial) {
          _records = [];
          numberOfRecords = response.records.length;
        }
        
        // add records to state result object
        response.records.forEach(record => {
          _records.push(record);
        });

        // assemble result object
        const _result = {
          records: _records,
          referenced: response.referenced,
          numberOfRecordsTotal: count, 
          numberOfRecords: numberOfRecords
        }
        
        // set result and pagination
        setResult(_result)
        setPagination(query.pagination)
      }

      // hide loading animation
      setIsSearching(false);

    } catch (err) {
      //setError(err.message);
      console.error(err.message);
      setIsSearching(false);
    }
  };



  // build menu groups
  const menu_itmes_global = systemdata_groups.global.map((item) => {
    return <MenuItem key={item.key} name={item.name} active={activeItem === item.key} onClick={() => handleMenuItemClick(item.key, item.name) } />
  });
  const menu_itmes_object = systemdata_groups.object.map((item) => {
    return <MenuItem key={item.key} name={item.name} active={activeItem === item.key} onClick={() => handleMenuItemClick(item.key, item.name)} />
  });
  const menu_itmes_contract = systemdata_groups.contract.map((item) => {
    return <MenuItem key={item.key} name={item.name} active={activeItem === item.key} onClick={() => handleMenuItemClick(item.key, item.name)} />
  });

  return (
    <Grid>
      <GridRow>
        <GridColumn width={2}>
          <Menu pointing secondary vertical style={{width: '12rem'}}>
            <MenuItem>
              <MenuHeader>Allgemein</MenuHeader>
              <MenuMenu>
                {menu_itmes_global}
              </MenuMenu>
            </MenuItem>

            <MenuItem>
              <MenuHeader>Objekt / Produkt</MenuHeader>
              <MenuMenu>
                {menu_itmes_object}
              </MenuMenu>
            </MenuItem>

            <MenuItem>
              <MenuHeader>Vertrag</MenuHeader>
              <MenuMenu>
                {menu_itmes_contract}
              </MenuMenu>
            </MenuItem>
          </Menu>
        </GridColumn>
        
        <GridColumn stretched width={14}>
          {activeItem && !isSearching && (
            <>
              <Segment style={{backgroundColor: '#f5f5f5'}}>
                <Header as='h4'>Filter</Header>
                <Max2SettingsSystemDataFilter activeItem={activeItem} resultData={result} loadTableData={loadTableData} searchFilter={searchFilter} setSearchFilter={setSearchFilter} />
              </Segment>

              <Header as='h4'>Datensätze: {result.numberOfRecords} von {result.numberOfRecordsTotal}</Header>
            </>
          )}
          <div style={{overflow: 'auto', height: 'calc(100vh - 400px)'}}>
            {activeItem && isSearching && (<Max2SettingsSystemDataSearching />)}
            {activeItem && !isSearching && systemdata_definitions[activeItem].displayAs === 'single' && (<Max2SettingsSystemDataSingle activeItem={activeItem} resultData={result} handleMenuItemClick={handleMenuItemClick} />)}
            {activeItem && !isSearching && systemdata_definitions[activeItem].displayAs === 'table' && (<Max2SettingsSystemDataTable activeItem={activeItem} resultData={result} handleMenuItemClick={handleMenuItemClick} />)}
            {activeItem && !isSearching && (
              <>{parseInt(result.numberOfRecords) < parseInt(result.numberOfRecordsTotal) ? <Button basic circular onClick={() => loadTableData(activeItem, false, searchFilter)}>mehr...</Button> : <></>}</>
            )}
          </div>
        </GridColumn>
      </GridRow>
    </Grid>
  );
}



/**
 * 
 * @returns 
 */
const Max2SettingsSystemDataFilter = ({activeItem, resultData, loadTableData, searchFilter, setSearchFilter}) => {
  // local state
  //const [searchFilter, setSearchFilter]     = useState({});



  /**
   * 
   * @param {string} column 
   * @param {mixed} value 
   */
  const handleFilterChange = (column, type, value ) => {
    let _filter = {...searchFilter };
    _filter[column] = { enabled: true, value: value, type: type };
    
    setSearchFilter(_filter)
  }



  /**
   * 
   */
  const handleResetFilterClick = () => {
    setSearchFilter({})
    loadTableData(activeItem, true, true)
  }
  


  /**
   * 
   */
  const handleFilterClick = () => {
    loadTableData(activeItem, true, searchFilter)
  }



  /**
   * only float numbers allowed (Prices, Reductions)
   * @param {*} e 
   */
  const handleKeyPressFloat = (e) => {
    if (!/^\d{0,4}(\.\d{0,2})?$/.test(e.key)) {
      e.preventDefault();
    }
  };
  


  /**
   * only numbers allowed (Allotment, Ages)
   * @param {event} e 
   */
  const handleKeyPressNumber = (e) => {
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };


  return (
    <Form>
      <FormGroup>

      
        {systemdata_definitions[activeItem].columns.map((column) => {
          const val = searchFilter[column.NAME]?.value ? searchFilter[column.NAME]?.value : '';
          if (column.FK) {
            return (
              <FormField key={column.NAME}>
                <FormSelect 
                  selection
                  clearable
                  search
                  fluid
                  style    = {{minWidth: '75px'}} 
                  label    = {column.TITLE}
                  value    = {val} 
                  options  = {resultData.referenced[systemdata_definitions[column.FK.TABLE]?.table]?.map((col)=>{ return {key: col[column.FK.FK], value: col[column.FK.FK], text: col[column.FK.COLUMN_TO_DISPLAY]}; })} 
                  onChange = {(e, data) => handleFilterChange(column.NAME, column.TYPE, data.value) }
                />
              </FormField>
            )
          }
          switch (column.TYPE) {
            case 2: return (<FormField key={column.NAME}><FormInput fluid style={{minWidth:  '75px'}} label={column.TITLE} value={val} onChange={(e) => handleFilterChange(column.NAME, column.TYPE, e.target.value) } onKeyPress={handleKeyPressNumber} /></FormField>);
            case 3: return (<FormField key={column.NAME}><FormInput fluid style={{minWidth: '250px'}} label={column.TITLE} value={val} onChange={(e) => handleFilterChange(column.NAME, column.TYPE, e.target.value) }/></FormField>);
            case 4: return (<FormField key={column.NAME}><FormInput fluid style={{minWidth:  '75px'}} label={column.TITLE} value={val} onChange={(e) => handleFilterChange(column.NAME, column.TYPE, e.target.value) }/></FormField>);
            case 5: 
              return (
                <FormField key={column.NAME}>
                  <DatePicker
                    showWeekNumbers
                    selected    = {val}
                    dateFormat  = "dd.MM.yyyy"
                    placeholder = 'TT.MM.JJJJ'
                    onChange    = {(date)=>handleFilterChange(column.NAME, column.TYPE, date ? format(date, "yyyy-MM-dd") : null)} 
                    customInput = {<FormInput label={column.TITLE} icon='calendar alternate' iconPosition='left' placeholder='TT.MM.JJJJ' style={{width: "150px"}} />}
                  />
                </FormField>
              );
            case 6: return <></>;
            case 7: return (<FormField key={column.NAME}><FormInput fluid style={{minWidth:  '75px'}} label={column.TITLE} value={val} onChange={(e) => handleFilterChange(column.NAME, column.TYPE, e.target.value) } onKeyPress = {handleKeyPressFloat}/></FormField>);
            default: return <FormField key={column.NAME}><FormInput fluid style={{minWidth: '150px'}} label={column.TITLE} value={val} onChange={(e) => handleFilterChange(column.NAME, column.TYPE, e.target.value) }/></FormField>;
          }
        })}
        <FormField>
          <div style={{marginTop: '25px'}}>
            <Button primary circular icon labelPosition='left' onClick={()=>handleFilterClick()}><Icon name="filter" /> Filtern</Button>
            <Button basic circular icon='times' onClick={() => handleResetFilterClick()} />
          </div>
        </FormField>
      </FormGroup>
    </Form>
  )
}



/**
 * 
 * @returns 
 */
const Max2SettingsSystemDataSearching = () => {
  return (
    <Header as='h2' textAlign='center'>
      <Icon loading name='spinner' />
      <HeaderContent>Datenbank wird durchsucht</HeaderContent>
    </Header>
  )
}



/**
 * 
 * @param {string} activeItem 
 * @param {object} resultData 
 * @returns 
 */
const Max2SettingsSystemDataSingle = ({activeItem, resultData}) => {
  // local state
  const [result, setResult]                 = useState(resultData);
  const [editRecord, setEditRecord]         = useState(null);
  const [recordDataOld, setRecordDataOld]   = useState(null);
  
  // global state
  const dispatch    = useDispatch();
  const backendUrl  = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);

  // Snackbar
  const { enqueueSnackbar } = useSnackbar();



  /**
   * 
   * @param {int} recordIndex 
   * @param {object} record 
   */
  const handleEditRecordClick = (recordIndex, record) => {
    setRecordDataOld({...record});
    setEditRecord(recordIndex);
  }



  /**
   * 
   */
  const handleAbortEditRecordClick = () => {    
    let _result = {...result};
    let _records = [...result.records];
    _records[editRecord] = recordDataOld;
    _result.records = _records;

    setResult(_result);
    setEditRecord(null);
    setRecordDataOld(null);
  }



  /**
   * @param {string} column 
   * @param {string} value 
   */
  const handleChangeRecordData = (column, value) => {
    let _result = {...result};
    let _records = [...result.records];
    _records[editRecord][column] = value;
    _result.records = _records;
    
    setResult(_result);
  }



  /**
   *
   */
  const handleSaveClick = async () => {
    const _record = {...result.records[editRecord]};
    
    try {
      // Controller for AJAX requests
      const api = new AjaxController(backendUrl, () => {
            dispatch(setActivePage('START'));
            dispatch(setUser(null));
            dispatch(setToken(null));
          });

      //
      const data = {
        record: _record,
        definition: systemdata_definitions[activeItem]
      }

      // send post request
      const response = await api.put('/settings/systemdata/' + activeItem, data);
      console.log(response);
      if (response?.status === 'success') {
        handleAbortEditRecordClick();
        enqueueSnackbar('Systemdaten wurden gespeichert', { variant: 'success' });
        setEditRecord(null);
        setRecordDataOld(null);
      }
    } catch (err) {
      enqueueSnackbar('Fehler beim Speichern der Systemdaten', { variant: 'error' });
      console.error(err.message);
      handleAbortEditRecordClick();
    }
  }
  

  if (!result?.records?.length) {
    return (
      <Header as='h2' textAlign='center'>
        <Icon name='ban' />
        <HeaderContent>Keine Daten gefunden</HeaderContent>
      </Header>
    )
  }


  return (
    <>
    {result?.records.map((record, recordIndex) => {
      const rows = systemdata_definitions[activeItem]?.columns.map((column, columnIndex) => {

        // Edit mode
        if (editRecord !== null && editRecord === recordIndex && !column.PK) {
          if (column.FK) {
            return (
              <FormGroup key={columnIndex}>
                <FormField width={4}><label>{column.TITLE}</label></FormField>
                <FormField width={12}>
                  <FormSelect 
                    selection 
                    clearable 
                    search 
                    value = {record[column.NAME]} 
                    options = {result.referenced[systemdata_definitions[column.FK.TABLE]?.table]?.map((col)=>{ return {key: col[column.FK.FK], value: col[column.FK.FK], text: col[column.FK.COLUMN_TO_DISPLAY]}; })} 
                    onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)}
                  />
                </FormField>
              </FormGroup>
            );
          }
          let formField = <></>;
          switch (column.TYPE) {
            case 2: formField = (<FormInput fluid value={record[column.NAME]} onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)} />); break;
            case 3: formField = (<FormInput fluid value={record[column.NAME]} onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)} />); break;
            case 4: formField = (<FormInput fluid value={record[column.NAME]} onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)} />); break;
            case 5: formField = (<FormInput fluid value={record[column.NAME]} onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)} />); break;
            case 6: formField = (<FormTextArea fluid rows={5} value={record[column.NAME]} onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)} />); break;
            case 7: formField = (<FormInput fluid value={record[column.NAME]} onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)} />); break;
            default: formField = <></>;
          }
          return (
            <FormGroup key={columnIndex}>
              <FormField width={4}><label>{column.TITLE}</label></FormField>
              <FormField width={12}>{formField}</FormField>
            </FormGroup>
          );
        }


        // readonly mode
        if (column.FK) {
          let val = record[column.NAME];
          const fk_tab = systemdata_definitions[column.FK.TABLE]?.table;
          result.referenced[fk_tab].forEach(fk => {
            if (fk[column.FK.FK] === val) {
              val = fk[column.FK.COLUMN_TO_DISPLAY];
            }
          });
          return (
            <FormGroup key={columnIndex}>
              <FormField width={4}><label>{column.TITLE}</label></FormField>
              <FormField width={12}>{val}</FormField>
            </FormGroup>
          )
        }

        let recordValue = <></>;
        switch (column.TYPE) {
          case 1: recordValue = record[column.NAME]; break;
          case 2: recordValue = record[column.NAME]; break;
          case 3: recordValue = record[column.NAME]; break;
          case 4: recordValue = format(new Date(record[column.NAME]), 'dd.MM.yyyy HH:mm:ss');  break;
          case 5: recordValue = format(new Date(record[column.NAME]), 'dd.MM.yyyy'); break;
          case 6: recordValue = record[column.NAME]; break;
          case 7: recordValue = record[column.NAME].replace('.', ','); break;
          default: recordValue = record[column.NAME]; break;
        }

        return (
          <FormGroup key={columnIndex}>
            <FormField width={4}><label>{column.TITLE}</label></FormField>
            <FormField width={12}>{recordValue}</FormField>
          </FormGroup>
        )
      })

      // Buttons
      const buttons = editRecord !== null && editRecord === recordIndex 
      ? <>
        <Button basic circular negative icon='trash' />
        <Button basic circular          icon='times' onClick={()=>handleAbortEditRecordClick()} />
        <Button basic circular primary  icon='save'  onClick={()=>handleSaveClick()} />
        </>
      : <Button basic circular icon='edit' onClick={()=>handleEditRecordClick(recordIndex, record)} />


      return (
        <Card key={recordIndex} style={{width: '999px', background: '#fcfcfc', borderRadius: '15px'}}>
          {systemdata_definitions[activeItem].titleColumn && (
            <CardContent>
              {systemdata_definitions[activeItem]?.columns.map((column) => {
                if (column.NAME === systemdata_definitions[activeItem].titleColumn) {
                  return <CardHeader>{record[column.NAME]}</CardHeader>
                } else {
                  return <></>
                }
              })}
              <CardMeta>{(recordIndex+1)} von {result.numberOfRecordsTotal}</CardMeta>
              <CardDescription style={{position: 'absolute', right: '10px', top: '10px'}}>{buttons}</CardDescription>
            </CardContent>
          )}
          <CardContent>
            <CardDescription>
              <Form>
                {rows}
              </Form>
            </CardDescription>
          </CardContent>
        </Card>
      )
    })
  }
  </>
  )
}



/**
 * 
 * @param {string} activeItem 
 * @param {object} resultData 
 * @returns 
 */
const Max2SettingsSystemDataTable = ({activeItem, resultData, handleMenuItemClick}) => {
  // local state
  const [result, setResult]                 = useState(resultData);
  const [editRecord, setEditRecord]         = useState(null);
  const [recordDataOld, setRecordDataOld]   = useState(null);
  const [openModal, setOpenModal]           = useState(false);
  const [newRecord, setNewRecord]           = useState({});
  
  // global state
  const dispatch    = useDispatch();
  const backendUrl  = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);

  // Snackbar
  const { enqueueSnackbar } = useSnackbar();



  /**
   * 
   * @param {int} recordIndex 
   * @param {object} record 
   */
  const handleEditRecordClick = (recordIndex, record) => {
    setRecordDataOld({...record});
    setEditRecord(recordIndex);
    //setOpenModal(true);
  }



  /**
   * 
   */
  const handleAbortEditRecordClick = () => {    
    let _result = {...result};
    let _records = [...result.records];
    _records[editRecord] = recordDataOld;
    _result.records = _records;

    setResult(_result);
    setEditRecord(null);
    setRecordDataOld(null);
  }


  
  /**
   * only float numbers allowed (Prices, Reductions)
   * @param {*} e 
   */
  const handleKeyPressFloat = (e) => {
    if (!/^\d{0,4}(\.\d{0,2})?$/.test(e.key)) {
      e.preventDefault();
    }
  };
  

  /**
   * only numbers allowed (Allotment, Ages)
   * @param {event} e 
   */
  const handleKeyPressNumber = (e) => {
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };



  /**
   * @param {string} column 
   * @param {string} value 
   */
  const handleChangeRecordData = (column, value) => {
    let _result = {...result};
    let _records = [...result.records];
    _records[editRecord][column] = value;
    _result.records = _records;
    
    setResult(_result);
  }



  /**
   *
   */
  const handleSaveClick = async () => {
    const _record = {...result.records[editRecord]};
    
    try {
      // Controller for AJAX requests
      const api = new AjaxController(backendUrl, () => {
            dispatch(setActivePage('START'));
            dispatch(setUser(null));
            dispatch(setToken(null));
          });

      //
      const data = {
        record: _record,
        definition: systemdata_definitions[activeItem]
      }

      // send post request
      const response = await api.put('/settings/systemdata/' + activeItem, data);
      if (response?.status === 'success') {
        handleAbortEditRecordClick();
        enqueueSnackbar('Systemdaten wurden gespeichert', { variant: 'success' });
        setEditRecord(null);
        setRecordDataOld(null);
      }
    } catch (err) {
      enqueueSnackbar('Fehler beim Speichern der Systemdaten', { variant: 'error' });
      console.error(err.message);
      handleAbortEditRecordClick();
    }
  }
  


  const handleAddNewRecordClick = () => {
    setOpenModal(true);
  }



  /**
   * @param {string} column 
   * @param {string} value 
   */
  const handleChangeNewRecordData = (column, value) => {
    let _newRecord = {...newRecord};
    _newRecord[column] = value;
    setNewRecord(_newRecord);
  }



  const handleSaveNewRecordClick = async () => {
    try {
      // Controller for AJAX requests
      const api = new AjaxController(backendUrl, () => {
            dispatch(setActivePage('START'));
            dispatch(setUser(null));
            dispatch(setToken(null));
          });

      //
      const data = {
        record: newRecord,
        definition: systemdata_definitions[activeItem]
      }

      // send post request
      const response = await api.post('/settings/systemdata/' + activeItem, data);
      if (response?.status === 'success') {
        enqueueSnackbar('Neuer Datensatz erfolgreich angelegt', { variant: 'success' });
        setOpenModal(false);
        setNewRecord({});
        
        handleMenuItemClick(activeItem, systemdata_definitions[activeItem].NAME)
      }
    } catch (err) {
      enqueueSnackbar('Fehler beim Anlegen des neuen Datensatzes', { variant: 'error' });
    }
  } 



  if (!result?.records?.length) {
    return (
      <Header as='h2' textAlign='center'>
        <Icon name='ban' />
        <HeaderContent>Keine Daten gefunden</HeaderContent>
      </Header>
    )
  }


  return (
    <>

    {/* New-Record Modal */}
    <Modal size="large" open={openModal} onClose={()=>setOpenModal(false)}>
      <Modal.Header>Neuen Datensatz anlegen</Modal.Header>
      <Modal.Content>
        <Segment textAlign='left' style={{ margin: '10px', padding: '50px' }}>
          <Form>
            {systemdata_definitions[activeItem]?.columns.map((column) => {
              if (!column.PK) {
                if (column.FK) {
                  return (
                    <FormSelect 
                      selection 
                      clearable 
                      search
                      label = {column.TITLE}
                      value = {newRecord[column.NAME]} 
                      options = {result.referenced[systemdata_definitions[column.FK.TABLE]?.table]?.map((col)=>{ return {key: col[column.FK.FK], value: col[column.FK.FK], text: col[column.FK.COLUMN_TO_DISPLAY]}; })} 
                      onChange = {(e, data) => handleChangeNewRecordData(column.NAME, data.value)}
                      />
                  );
                }
                switch (column.TYPE) {
                  case 2: return (<FormInput value={newRecord[column.NAME]} label={column.TITLE} onChange = {(e, data) => handleChangeNewRecordData(column.NAME, data.value)} onKeyPress={handleKeyPressNumber} />);
                  case 3: return (<FormInput value={newRecord[column.NAME]} label={column.TITLE} onChange = {(e, data) => handleChangeNewRecordData(column.NAME, data.value)} />);
                  case 4: return (<FormInput value={newRecord[column.NAME]} label={column.TITLE} onChange = {(e, data) => handleChangeNewRecordData(column.NAME, data.value)} />);
                  case 5: 
                    return (
                      <DatePicker
                        showWeekNumbers
                        selected    = {newRecord[column.NAME]}
                        dateFormat  = "dd.MM.yyyy"
                        placeholder = 'TT.MM.JJJJ'
                        onChange    = {(date)=>handleChangeRecordData(column.NAME, column.TYPE, date ? format(date, "yyyy-MM-dd") : null)} 
                        customInput = {<FormInput label={column.TITLE} icon='calendar alternate' iconPosition='left' placeholder='TT.MM.JJJJ' style={{width: "150px", marginRight: '10px', marginBottom: '10px'}} />}
                      />
                    ); 
                  case 6: return  (<FormInput value={newRecord[column.NAME]} label={column.TITLE} onChange = {(e, data) => handleChangeNewRecordData(column.NAME, data.value)} />);
                  case 7: return  (<FormInput value={newRecord[column.NAME]} label={column.TITLE} onChange = {(e, data) => handleChangeNewRecordData(column.NAME, data.value)} onKeyPress = {handleKeyPressFloat} />);
                  default: return (<FormInput value={newRecord[column.NAME]} label={column.TITLE} onChange = {(e, data) => handleChangeNewRecordData(column.NAME, data.value)} />);
                }
              }
              return <></>
            })}
          </Form>
        </Segment>
      </Modal.Content>
      <Modal.Actions>
        <Button basic circular icon labelPosition='left' onClick={() => setOpenModal(false)}><Icon name='times' />Schließen</Button>
        <Button primary circular icon labelPosition='left' onClick={() => handleSaveNewRecordClick()}><Icon name='save' />anlegen</Button>
      </Modal.Actions>
    </Modal>


    {/* Record list */}
    <div style={{ minWidth: 'calc(100vw - 360px)', maxHeight: "calc(100vh - 500px)", overflowY: "auto" }}>
      <Table basic='very' singleLine collapsing selectable fixed>
        <TableHeader>
          <TableRow>
            {systemdata_definitions[activeItem].columns.map((column) => {
              return <TableHeaderCell key={column.NAME} style={{ position: "sticky", top: 0, zIndex: 2, background: "white" }}>{column.TITLE}</TableHeaderCell>
            })}
            <TableHeaderCell collapsing style={{ position: "sticky", top: 0, zIndex: 2, background: "white" }}>
              <Button primary circular icon='add' onClick={() => handleAddNewRecordClick()} />
            </TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {result?.records.map((record, recordIndex) => {
            const columns = systemdata_definitions[activeItem]?.columns.map((column, columnIndex) => {

              // Edit Mode
              if (editRecord !== null && editRecord === recordIndex && !column.PK) {
                if (column.FK) {
                  return (
                    <TableCell key={columnIndex}>
                      <FormSelect 
                        selection 
                        clearable 
                        search
                        fluid
                        value = {record[column.NAME]} 
                        options = {result.referenced[systemdata_definitions[column.FK.TABLE]?.table]?.map((col)=>{ return {key: col[column.FK.FK], value: col[column.FK.FK], text: col[column.FK.COLUMN_TO_DISPLAY]}; })} 
                        onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)}
                      />
                    </TableCell>
                  );
                }
                switch (column.TYPE) {
                  case 2: return (<TableCell key={columnIndex}><FormInput value={record[column.NAME]} onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)} onKeyPress={handleKeyPressNumber} /></TableCell>);
                  case 3: return (<TableCell key={columnIndex}><FormInput value={record[column.NAME]} onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)} /></TableCell>);
                  case 4: return (<TableCell key={columnIndex}><FormInput value={record[column.NAME]} onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)} /></TableCell>);
                  case 5: 
                    return (
                      <TableCell key={columnIndex}>
                        <DatePicker
                          showWeekNumbers
                          selected    = {record[column.NAME]}
                          dateFormat  = "dd.MM.yyyy"
                          placeholder = 'TT.MM.JJJJ'
                          onChange    = {(date)=>handleChangeRecordData(column.NAME, column.TYPE, date ? format(date, "yyyy-MM-dd") : null)} 
                          customInput = {<FormInput icon='calendar alternate' iconPosition='left' placeholder='TT.MM.JJJJ' style={{width: "150px"}} />}
                        />
                      </TableCell>
                    ); 
                  case 6: return (<TableCell key={columnIndex}><FormInput value={record[column.NAME]} onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)} /></TableCell>);
                  case 7: return (<TableCell key={columnIndex}><FormInput value={record[column.NAME]} onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)} onKeyPress = {handleKeyPressFloat} /></TableCell>);
                  default: return (<TableCell key={columnIndex}><FormInput value={record[column.NAME]} onChange = {(e, data) => handleChangeRecordData(column.NAME, data.value)} /></TableCell>);
                }
              }

              // Readonly Mode
              if (column.FK) {
                let val = record[column.NAME];
                const fk_tab = systemdata_definitions[column.FK.TABLE]?.table;
                result.referenced[fk_tab].forEach(fk => {
                  if (fk[column.FK.FK] === val) {
                    val = fk[column.FK.COLUMN_TO_DISPLAY];
                  }
                });
                return <TableCell key={columnIndex}>{val}</TableCell>
              }
              switch (column.TYPE) {
                case 1:  return <TableCell key={columnIndex}>{record[column.NAME]}</TableCell>;
                case 2:  return <TableCell key={columnIndex}>{record[column.NAME]}</TableCell>;
                case 3:  return <TableCell key={columnIndex}>{record[column.NAME]}</TableCell>;
                case 4:  return <TableCell key={columnIndex}>{format(new Date(record[column.NAME]), 'dd.MM.yyyy HH:mm:ss')}</TableCell>;
                case 5:  return <TableCell key={columnIndex}>{format(new Date(record[column.NAME]), 'dd.MM.yyyy')}</TableCell>;
                case 6:  return <TableCell key={columnIndex}>{record[column.NAME]}</TableCell>;
                case 7:  return <TableCell key={columnIndex}>{record[column.NAME].replace('.', ',')}</TableCell>;
                default: return <TableCell key={columnIndex}>{record[column.NAME]}</TableCell>
              }; 
            })

            // build edit row buttons
            const buttons = editRecord !== null && editRecord === recordIndex 
            ? <>
              <Button basic circular negative icon='trash' />
              <Button basic circular icon='times' onClick={()=>handleAbortEditRecordClick()} />
              <Button primary circular icon='save' onClick={()=>handleSaveClick()} />
              </>
            : <Button basic circular icon='edit' onClick={()=>handleEditRecordClick(recordIndex, record)} />

            return (
              <TableRow key={recordIndex}>
                {columns}
                <TableCell>{buttons}</TableCell>              
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </div>

    </>
  )
}

























































export default Max2SettingsSystemData;